var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregiverCaseload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.16 47.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.58,
    cy: 23.58,
    r: 23.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.66,298.6v1.14a2,2,0,0,1-2,2H279.75a2,2,0,0,1-2-2.06V276.92a2,2,0,0,1,2.09-2.1h9.54v10.54l2.92-3,2.91,3V274.86a2,2,0,0,1,2.44,1.78v8.5a5.34,5.34,0,0,1,.71-.07c.14,0,.26,0,.4,0v-8.26a3.07,3.07,0,0,0-3.13-3.15H279.77a3.08,3.08,0,0,0-3.13,3.14q0,11.45,0,22.87a3.07,3.07,0,0,0,3.13,3.15h15.83a3.06,3.06,0,0,0,3.16-3.17v-1.23a5.14,5.14,0,0,1-1.13.05S297.67,298.6,297.66,298.6Z",
    transform: "translate(-264.45 -264.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.5,299.28h-5.84a1.11,1.11,0,0,1-.26,0,.45.45,0,0,1,0-.9h12.13a.44.44,0,0,1,.41.4.42.42,0,0,1-.34.49,1.56,1.56,0,0,1-.31,0Z",
    transform: "translate(-264.45 -264.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.76,295.18h5.12a.79.79,0,0,1,.34.06.41.41,0,0,1,.24.44.44.44,0,0,1-.32.39,1.62,1.62,0,0,1-.31,0h-10.3c-.33,0-.53-.19-.53-.47s.21-.44.53-.44Z",
    transform: "translate(-264.45 -264.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.18,292.9h-4.8a.45.45,0,0,1,0-.89H290a.44.44,0,0,1,.37.44.45.45,0,0,1-.37.45h-4.84Z",
    transform: "translate(-264.45 -264.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284,285.44h3.4a.47.47,0,0,1,.42.42.45.45,0,0,1-.35.46.92.92,0,0,1-.29,0h-6.36c-.42,0-.66-.17-.65-.47s.23-.44.65-.44Z",
    transform: "translate(-264.45 -264.67)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284,288.83h-3.18a.74.74,0,0,1-.26,0,.43.43,0,0,1-.37-.42.42.42,0,0,1,.32-.43.82.82,0,0,1,.28,0h6.45a.78.78,0,0,1,.22,0,.47.47,0,0,1,.38.46.47.47,0,0,1-.44.43H284Z",
    transform: "translate(-264.45 -264.67)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.1,287.86a4.61,4.61,0,0,0,.39-.36,3.15,3.15,0,0,1,4.81.22,3.76,3.76,0,0,1-.22,4.94c-.45.47-.95.91-1.43,1.35l-3.42,3.15-.1.09-.07-.05L293.54,293a4.21,4.21,0,0,1-1.31-2.11,3.76,3.76,0,0,1,1.42-3.88,3.14,3.14,0,0,1,4.06.4Zm0,8.68a.36.36,0,0,0,.09-.08l2.73-2.5c.59-.55,1.2-1.08,1.75-1.66a3.21,3.21,0,0,0,0-4.45,2.52,2.52,0,0,0-2-.84,2.55,2.55,0,0,0-1.91.88l-.74.78a.53.53,0,0,0-.09-.11c-.26-.28-.51-.58-.79-.85a2.58,2.58,0,0,0-3.36-.17,3.12,3.12,0,0,0-1.15,3.2,3.41,3.41,0,0,0,1.16,1.91l3.31,3Z",
    transform: "translate(-264.45 -264.67)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiverCaseload);
export default __webpack_public_path__ + "static/media/caregiver_caseload.2e5fb09fd5a1c8f02c39a43d9a86f206.svg";
export { ForwardRef as ReactComponent };